function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.25 6.25h9m-9 3h4.5M1 10.76c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L10.75 19l2.755-4.133a1.14 1.14 0 01.865-.501 48.167 48.167 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V4.741c0-1.602-1.123-2.995-2.707-3.228A48.395 48.395 0 0010.75 1c-2.392 0-4.744.175-7.043.513C2.123 1.746 1 3.14 1 4.741v6.019z",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));